import { Suspense } from 'react';
import { Banner, Stack } from '@optimus-web/core';
import { Loader } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { AddRecipientsSection } from './AddRecipientsSection';
import { AddEmailSection } from './AddEmailSection';
import { AddDeadlineSection } from './AddDeadlineSection';

export const RecipientsStepForm = () => {
    return (
        <Suspense fallback={<Loader />}>
            <Stack vertical spacing="400">
                <AddRecipientsSection />
                <AddEmailSection />
                <AddDeadlineSection />
                <Banner variant="info" secondaryText={lt('ContractsGenerateContractPreviewBannerMessage')} />
            </Stack>
        </Suspense>
    );
};
